// extracted by mini-css-extract-plugin
export default {"title":"admin-panel-header_title__oQCYD","button":"admin-panel-header_button__pEhKT","icon":"admin-panel-header_icon__wkz5g"};